export default "__VITE_ASSET__BrbiVOe5__"